// extracted by mini-css-extract-plugin
var _1 = "VersionChangesDropdown-module__active--iZwmM";
var _2 = "VersionChangesDropdown-module__animateUploadProgressBarWidth--U24KZ";
var _3 = "VersionChangesDropdown-module__animatedBackground--UJ_4I";
var _4 = "VersionChangesDropdown-module__calendarDay--IdKyS";
var _5 = "VersionChangesDropdown-module__calendarDayWeekday--FMqWN";
var _6 = "VersionChangesDropdown-module__dropdownContent--bbjxp";
var _7 = "VersionChangesDropdown-module__dropdownRow--ALliH";
var _8 = "VersionChangesDropdown-module__dropdownRowCalendarDay--JdxDo";
var _9 = "VersionChangesDropdown-module__dropdownRowContent--WS87N";
var _a = "VersionChangesDropdown-module__dropdownRowSubtitle--Sg5PO";
var _b = "VersionChangesDropdown-module__dropdownRowTitle--sx5Zk";
var _c = "VersionChangesDropdown-module__restrictedHistories--vYLBW";
var _d = "VersionChangesDropdown-module__sectionTitle--dE9ne";
var _e = "VersionChangesDropdown-module__sectionTitleBadge--RvuoD";
var _f = "VersionChangesDropdown-module__versionButton--SvcD3";
var _10 = "VersionChangesDropdown-module__versionButtonCaret--_mTIy";
export { _1 as "active", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "calendarDay", _5 as "calendarDayWeekday", _6 as "dropdownContent", _7 as "dropdownRow", _8 as "dropdownRowCalendarDay", _9 as "dropdownRowContent", _a as "dropdownRowSubtitle", _b as "dropdownRowTitle", _c as "restrictedHistories", _d as "sectionTitle", _e as "sectionTitleBadge", _f as "versionButton", _10 as "versionButtonCaret" }
